function initializeReviewsSwiper() {
  var swiper = new Swiper(".reviews-umySwiper", {
    spaceBetween: 20,
    loop: true,
    slidesPerView: 4,
    speed: 400,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });
}